export const BuildingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentcolor"
      d="M14 8h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2Zm0 4h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2ZM9 8h1a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2Zm0 4h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2Zm12 8h-1V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v17H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Zm-8 0h-2v-4h2v4Zm5 0h-3v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5H6V4h12v16Z"
    />
  </svg>
);

export const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentcolor"
      d="M3.03 6a16.26 16.26 0 0 1-.01-1.43 1 1 0 0 1 .54-.7c.09-.04.2-.07.4-.13L6 3.2c.58-.15.87-.23 1.12-.16a1 1 0 0 1 .34.16c.21.16.34.43.58.98l.32.73c.37.85.56 1.27.62 1.68a3 3 0 0 1-.61 2.27c-.25.33-.63.6-1.37 1.14a13.06 13.06 0 0 0 7 7.01c.55-.74.83-1.11 1.15-1.37a3 3 0 0 1 2.28-.6c.4.05.82.24 1.67.61l.73.32c.55.25.83.37.98.58a1 1 0 0 1 .16.34c.07.26 0 .54-.16 1.12l-.54 2.04c-.06.2-.09.32-.13.4a1 1 0 0 1-.7.54c-.1.02-.2.02-.43.02a16.26 16.26 0 0 1-7.21-1.71A16.01 16.01 0 0 1 3.03 6Z"
    />
  </svg>
);

export const ClipboardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2v4H7V2h2.17a3 3 0 0 1 5.66 0H17Zm-5 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M3.88 2.88c.49-.5 1.14-.7 2.12-.8v2l-.03.01c-.57.08-.66.19-.68.2-.01.02-.12.11-.2.68C5 5.63 5 6.53 5 8v8c0 1.47 0 2.37.1 3.03.07.57.18.66.2.68 0 .01.1.12.67.2C6.63 20 7.53 20 9 20h6c1.47 0 2.37 0 3.03-.1.57-.07.66-.18.68-.2.01 0 .12-.1.2-.67.09-.66.09-1.56.09-3.03V8c0-1.47 0-2.37-.1-3.03-.07-.57-.18-.66-.2-.68 0-.01-.1-.12-.67-.2H18V2.08c.98.1 1.63.3 2.12.8.88.88.88 2.3.88 5.12v8c0 2.83 0 4.24-.88 5.12-.88.88-2.3.88-5.12.88H9c-2.83 0-4.24 0-5.12-.88C3 20.24 3 18.82 3 16V8c0-2.83 0-4.24.88-5.12Z"
    />
    <path
      fill="currentColor"
      d="M8 16a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8ZM7 13a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 8a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H8Z"
    />
  </svg>
);

export const MapPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 9.22C20 16.28 12 23 12 23S4 16.28 4 9.22A8.11 8.11 0 0 1 12 1c4.42 0 8 3.68 8 8.22ZM15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-9-6a1 1 0 1 0-2 0v5H8a1 1 0 1 0 0 2h5V6Z"
      clipRule="evenodd"
    />
  </svg>
);

export const BagIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 2 3 22h18L20 2H4Zm5.5 2a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5Z"
      clipRule="evenodd"
    />
  </svg>
);
